import * as React from "react";

export default class BMGLayoutComponent extends React.Component {

  render() {
    return (
      <div className="header">
        <div className="logo">
          <img className="img-logo" src="src/assets/images/logo-bmg.png" />
        </div>
      </div>
    )
  }
}